import React, { Component } from "react";
import PropTypes from "prop-types";
import { CustomInput } from "./style";

export default class CommonInputBox extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <CustomInput
        {...this.props}
      />
    );
  }
}

CommonInputBox.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  type: PropTypes.any,
  maxLength: PropTypes.number,
  pattern : PropTypes.any,
  min : PropTypes.any,
  onKeyPress : PropTypes.func,
  step : PropTypes.any,
  disabled : PropTypes.any

};